import { Provider } from '@angular/core';

import { VideoUseCasesImpl } from '@app/domain/use-cases/multimedia/video/video.use-cases';
import { VIDEO_USE_CASES } from '@app/domain/use-cases/multimedia/video/video.use-cases.contract';

export const videoUseCasesProvider: Provider = {
  provide: VIDEO_USE_CASES,
  useClass: VideoUseCasesImpl
};
